import { Stack } from '@mui/material';
import Access from './Access';
import Invitations from './Invitations';
import { withAccessControl } from '@/features/access-control';

const OrganizationPage = () => {
  return (
    <Stack spacing={2}>
      <Invitations />
      <Access />
    </Stack>
  );
};

export default withAccessControl(OrganizationPage, 'read.access');
